import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, IChartTemplate } from '../../model/chart-template.model'
import { act } from 'react-dom/test-utils'

export const ACTION_TYPES = {
  SEARCH_CHARTTEMPLATES: 'chartTemplate/SEARCH_CHARTTEMPLATES',
  FETCH_CHARTTEMPLATE_LIST: 'chartTemplate/FETCH_CHARTTEMPLATE_LIST',
  FETCH_CHARTTEMPLATE: 'chartTemplate/FETCH_CHARTTEMPLATE',
  CREATE_CHARTTEMPLATE: 'chartTemplate/CREATE_CHARTTEMPLATE',
  UPDATE_CHARTTEMPLATE: 'chartTemplate/UPDATE_CHARTTEMPLATE',
  DELETE_CHARTTEMPLATE: 'chartTemplate/DELETE_CHARTTEMPLATE',
  SET_BLOB: 'chartTemplate/SET_BLOB',
  RESET: 'chartTemplate/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IChartTemplate>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ChartTemplateState = Readonly<typeof initialState>;

// Reducer

export default (state: ChartTemplateState = initialState, action): ChartTemplateState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_CHARTTEMPLATES):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CHARTTEMPLATE):
    case REQUEST(ACTION_TYPES.UPDATE_CHARTTEMPLATE):
    case REQUEST(ACTION_TYPES.DELETE_CHARTTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_CHARTTEMPLATES):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATE):
    case FAILURE(ACTION_TYPES.CREATE_CHARTTEMPLATE):
    case FAILURE(ACTION_TYPES.UPDATE_CHARTTEMPLATE):
    case FAILURE(ACTION_TYPES.DELETE_CHARTTEMPLATE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_CHARTTEMPLATES):
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CHARTTEMPLATE):
    case SUCCESS(ACTION_TYPES.UPDATE_CHARTTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CHARTTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/chart-templates';
const apiSearchUrl = 'api/_search/chart-templates';

// Actions

export const getSearchEntities: ICrudSearchAction<IChartTemplate> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_CHARTTEMPLATES,
  payload: axios.get<IChartTemplate>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<IChartTemplate> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATE_LIST,
    payload: axios.get<IChartTemplate>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IChartTemplate> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATE,
    payload: axios.get<IChartTemplate>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IChartTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CHARTTEMPLATE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IChartTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CHARTTEMPLATE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IChartTemplate> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CHARTTEMPLATE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
